import React from 'react';
import Asset from '@src/components/Asset';
import Carousel from '@src/components/glide/Glide';
import { useViewport } from '@src/contexts/Viewport';

export default function TwoUpImages(props) {
    const { data } = props;
    const { isMobile } = useViewport();
    const carouselOptions = { type: 'slider', perView: 1, startAt: 0, peek: 0, gap: 24 };

    const items = data.assets.map(item => (
        <div key={item.title} className="flex justify-center">
            {item.assetLink ? (
                <a href={item.assetLink}>
                    <Asset data={item.imageFile} title={item.title} link />
                </a>
            ) : (
                <Asset data={item.imageFile} title={item.title} />
            )}
        </div>
    ));

    const carousel = (
        <Carousel enabled options={carouselOptions} bullets arrows>
            {items}
        </Carousel>
    );

    return (
        <>
            {isMobile && data.assets.length > 1 ? (
                carousel
            ) : (
                <div className="grid grid--2 grid--small-margin">{items}</div>
            )}
        </>
    );
}
